
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.866 9.434a.902.902 0 00-.884 1.075.9.9 0 001.633.324.899.899 0 00-.75-1.4zm0-4.031a.902.902 0 00-.884 1.075.9.9 0 001.633.324.899.899 0 00-.75-1.4zm3.144 1.8a.902.902 0 00-.901.899v.9a.9.9 0 001.538.636.9.9 0 00.264-.636v-.9a.9.9 0 00-.901-.9zm7.658-1.288a2.705 2.705 0 00-2.072-.26c-.36.096-.695.267-.982.503L3.163.121a.902.902 0 00-.901 0 .9.9 0 00-.46.782v11.851A2.649 2.649 0 000 15.3 2.698 2.698 0 002.631 18h.523a16.747 16.747 0 008.399-2.281 16.721 16.721 0 006.115-6.186 2.697 2.697 0 00-.991-3.618h-.009zM3.604 2.46l8.91 5.138a11.319 11.319 0 01-8.91 5.003V2.461zM16.1 8.65a14.928 14.928 0 01-5.65 5.63 14.953 14.953 0 01-7.747 1.92.901.901 0 01-.63-1.547.901.901 0 01.63-.252h.46a13.076 13.076 0 0011.37-6.632.811.811 0 01.522-.396.902.902 0 01.676.081.9.9 0 01.378 1.197H16.1z"}})])
          )
        }
      }
    